import clsx from 'clsx';

import styles from './ActionList.module.css';

export type Action = {
  id: number;
  title: string;
  onClick: VoidFunction;
  variant?: 'regular' | 'dangerous';
  disabled?: boolean;
};

export type Actions = (Action | false)[];

interface Props {
  actions: Actions;
}

/**
 * @example
 * <ActionsList actions={[
 *   { id: 0, title: 'Edit', onClick: () => {} },
 *   !isDisabled && { id: 0, title: 'Delete', onClick: () => {} }
 * ]} />
 * */
export function ActionList({ actions }: Props) {
  return (
    <div className={styles.list}>
      {actions.map(
        (action) =>
          !!action && (
            <div
              key={action.id}
              className={clsx(
                styles.listItem,
                action.variant === 'regular' && styles.listItemRegular,
                action.variant === 'dangerous' && styles.listItemDangerous,
                action.disabled && styles.listItemDisabled,
              )}
              onClick={action.disabled ? undefined : action.onClick}
            >
              {action.title}
            </div>
          ),
      )}
    </div>
  );
}
